module.exports = {"width":5388.25,"height":3229}


//////////////////
// WEBPACK FOOTER
// ./static/tech-city/metadata/artBoard.json
// module id = 2116
// module chunks = 80